import { render } from "./online-alv.nl.svg.vue?vue&type=template&id=3be8a266"
import script from "./online-alv.nl.svg.vue?vue&type=script&lang=js"
export * from "./online-alv.nl.svg.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaspur/Code/online-alv/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__